// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kw-0";
export var buttonContainer = "_kw-3";
export var cancelButton = "_kw-4";
export var headerSection = "_kw-6";
export var headerTitle = "_kw-9";
export var messageSideLeft = "_kw-1";
export var messageSideRight = "_kw-2";
export var orderNumberContainer = "_kw-7";
export var orderNumberLabel = "_kw-8";
export var submitButton = "_kw-5";